module.exports = "/dist/img/giftshopper_fabric1.d216b126.jpg";